module.exports = __webpack_public_path__ + "static/media/backdrop.81819158.jpg";